/**
 * Where Ω GEAR ships: every country Printful ships to that Stripe Checkout can also collect an
 * address for. Kept identical to TILL_SHIP_COUNTRIES in backend/api/checkout/_till.php — the
 * server refuses anything else (a test pins the two together).
 */
export const SHIP_COUNTRIES: readonly string[] =
  'AD,AE,AF,AG,AI,AL,AM,AO,AQ,AR,AT,AU,AW,AZ,BA,BB,BD,BE,BF,BG,BH,BI,BJ,BM,BN,BO,BR,BS,BT,BV,BW,BZ,CA,CD,CF,CG,CH,CI,CK,CL,CM,CN,CO,CR,CV,CW,CY,CZ,DE,DJ,DK,DM,DO,DZ,EC,EE,EG,EH,ER,ES,ET,FI,FJ,FK,FO,FR,GA,GB,GD,GE,GF,GG,GH,GI,GL,GM,GN,GP,GQ,GR,GS,GT,GU,GW,GY,HK,HN,HR,HT,HU,ID,IE,IL,IM,IN,IO,IQ,IS,IT,JE,JM,JO,JP,KE,KG,KH,KI,KM,KN,KR,KW,KY,KZ,LA,LB,LC,LI,LK,LR,LS,LT,LU,LV,LY,MA,MC,MD,ME,MF,MG,MK,ML,MM,MN,MO,MQ,MR,MS,MT,MU,MV,MW,MX,MY,MZ,NA,NC,NE,NG,NI,NL,NO,NP,NR,NU,NZ,OM,PA,PE,PF,PG,PH,PK,PL,PM,PN,PR,PS,PT,PY,QA,RE,RO,RS,RW,SA,SB,SC,SE,SG,SH,SI,SJ,SK,SL,SM,SN,SO,SR,ST,SV,SX,SZ,TC,TD,TF,TG,TH,TJ,TK,TL,TM,TN,TO,TR,TT,TV,TW,TZ,UA,UG,US,UY,UZ,VA,VC,VE,VG,VN,VU,WF,WS,XK,YE,YT,ZA,ZM,ZW'.split(
    ',',
  );

let names: Intl.DisplayNames | null | undefined;

/** The country's English name, or its code where the browser cannot name it. */
export function countryName(code: string): string {
  if (names === undefined) {
    try {
      names = new Intl.DisplayNames(['en'], { type: 'region' });
    } catch {
      names = null;
    }
  }
  return names?.of(code) ?? code;
}

/** The ship-to list, sorted by name (United States first: most orders ship there). */
export function shipCountryOptions(): { readonly code: string; readonly name: string }[] {
  const all = SHIP_COUNTRIES.map((code) => ({ code, name: countryName(code) }));
  all.sort((a, b) => (a.code === 'US' ? -1 : b.code === 'US' ? 1 : a.name.localeCompare(b.name)));
  return all;
}

/** A stored or browser-suggested country if the till ships there, else the United States. */
export function defaultShipCountry(stored: string | null, languages: readonly string[]): string {
  if (stored !== null && SHIP_COUNTRIES.includes(stored)) return stored;
  for (const tag of languages) {
    const region = /-([A-Z]{2})\b/i.exec(tag)?.[1]?.toUpperCase();
    if (region !== undefined && SHIP_COUNTRIES.includes(region)) return region;
  }
  return 'US';
}
